import { useId, useState, type ReactNode } from 'react';
import { Popover } from '@mantine/core';

export function NewsletterInfoTip({ label, children }: { label: string; children: ReactNode }) {
  const [opened, setOpened] = useState(false);
  const id = useId();
  return <Popover opened={opened} onChange={setOpened} onClose={() => setOpened(false)}
    position="top" withArrow width={300} withRoles={false} returnFocus={false}>
    <Popover.Target>
      <button type="button" className="newsletter-stat-info" aria-label={label}
        aria-describedby={opened ? id : undefined}
        onMouseEnter={() => setOpened(true)} onMouseLeave={() => setOpened(false)}
        onFocus={() => setOpened(true)} onBlur={() => setOpened(false)}
        onClick={event => { event.preventDefault(); setOpened(true); }}>i</button>
    </Popover.Target>
    <Popover.Dropdown role="tooltip" id={id} style={{maxWidth:'calc(100vw - 24px)',lineHeight:1.5}}>{children}</Popover.Dropdown>
  </Popover>;
}
